<!--
    Componente Modal Header Padrão - Exemplos de uso:

    Header básico:
    <ModalHeader
        icon="settings"
        title="Configurações"
        subtitle="Gerencie suas preferências"
    />

    Header com cor personalizada:
    <ModalHeader
        icon="trash"
        title="Excluir Item"
        subtitle="Esta ação não pode ser desfeita"
        color="red"
    />

    Header sem subtítulo:
    <ModalHeader
        icon="plus"
        title="Novo Cadastro"
    />
-->
<template>
    <div class="modalHeader">
        <div class="modalHeader_icon" :class="`modalHeader_icon--${color}`">
            <sw-icon :name="icon" />
        </div>
        <div class="modalHeader_title">
            <h3 class="modal-header-title">{{ title }}</h3>
            <span v-if="subtitle" class="modal-header-subtitle">{{ subtitle }}</span>
        </div>
    </div>
</template>

<script setup>
    import { MODAL_HEADER_COLORS } from '@/constants';

    const props = defineProps({
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: MODAL_HEADER_COLORS.BLUE,
            validator: (value) => Object.values(MODAL_HEADER_COLORS).includes(value)
        }
    });
</script>

<style scoped>
/* =============================================
   MODAL HEADER COMPONENT STYLES
   ============================================= */

.modalHeader {
    display: flex;
    align-items: center;
    gap: 1em;
    padding: 0;
}

.modalHeader_icon {
    width: 2.5em;
    height: 2.5em;
    border-radius: 0.5em;
    background: linear-gradient(135deg, var(--colorBlue, #3b82f6), var(--colorBlueDark, #1d4ed8));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25em;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    flex-shrink: 0;
}

.modalHeader_title {
    flex: 1;
    min-width: 0;
}

.modal-header-title {
    font-size: 1.25em !important;
    font-weight: 700;
    color: var(--textPrimary, #1f2937);
    margin: 0 0 0.25em 0;
    line-height: 1.2;
}

.modal-header-subtitle {
    font-size: 0.875em !important;
    font-weight: 500;
    color: var(--textSecondary, #64748b);
    line-height: 1.4;
    margin: 0;
}

/* Variações de Cor do Ícone */
.modalHeader_icon--blue {
    background: linear-gradient(135deg, var(--colorBlue, #3b82f6), var(--colorBlueDark, #1d4ed8));
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.modalHeader_icon--green {
    background: linear-gradient(135deg, var(--colorGreen, #10b981), var(--colorGreenDark, #059669));
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.modalHeader_icon--red {
    background: linear-gradient(135deg, var(--colorRed, #ef4444), var(--colorRedDark, #dc2626));
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.modalHeader_icon--orange {
    background: linear-gradient(135deg, var(--colorOrange, #f59e0b), var(--colorOrangeDark, #d97706));
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.modalHeader_icon--purple {
    background: linear-gradient(135deg, var(--colorPurple, #8b5cf6), var(--colorPurpleDark, #7c3aed));
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.modalHeader_icon--gray {
    background: linear-gradient(135deg, var(--colorGray, #6b7280), var(--colorGrayDark, #4b5563));
    box-shadow: 0 4px 12px rgba(107, 114, 128, 0.3);
}
</style>